<template>
    <div>
        <div class="myHead">
            <el-breadcrumb style="margin-top:20px;margin-left:20px" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/processManager/masterial'}">物资管理</el-breadcrumb-item>
                <el-breadcrumb-item>{{ $route.params.key ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="myCont" style="background: #fff;">
            <template style="background: #ffffff;">
                <el-form
                        :model="ruleForm"
                        :rules="rules"
                        ref="ruleForm"
                        label-width="100px"
                        class="demo-ruleForm"
                        style="width:60%;margin:0 auto;padding-top: 2%"
                >
                    <el-form-item label="物资编号" prop="name">
                        <el-input size="small" v-model="ruleForm.num	" style="width:500px"></el-input>
                    </el-form-item>
                    <el-form-item label="物资名称" prop="jobs">
                        <el-input size="small" v-model="ruleForm.name" style="width:500px"></el-input>
                    </el-form-item>
                    <el-form-item label="物资用途" prop="jobs">
                        <el-input size="small" v-model="ruleForm.purpose" style="width:500px"></el-input>
                    </el-form-item>
                    <el-form-item label="物资型号" prop="jobs">
                        <el-input size="small" v-model="ruleForm.model	" style="width:500px"></el-input>
                    </el-form-item>
                    <el-form-item label="负责部门" prop="jobs">
                        <el-input size="small" v-model="ruleForm.depName" style="width:500px"></el-input>
                    </el-form-item>
                    <el-form-item label="物资分类" prop="jobs">
                        <el-select size="small" v-model="ruleForm.classifyId" placeholder="请添加">
                            <el-option
                                    v-for="item in type"
                                    :key="item.id"
                                    :label="item.classifyName"
                                    :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="存放位置" prop="jobs">
                        <el-input size="small" v-model="ruleForm.position" style="width:500px"></el-input>
                    </el-form-item>
                    <el-form-item label="存储数量" prop="jobs">
                        <el-input-number
                                size="small"
                                v-model="ruleForm.amount"
                                controls-position="right"
                                :min="1"
                                :max="1000000"
                        ></el-input-number>
                        <el-button size="small">个</el-button>
                    </el-form-item>

                    <el-form-item label="生产日期" prop="jobs">
                        <el-date-picker
                                size="small"
                                v-model="ruleForm.pdDate"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                type="date"
                                placeholder="选择日期"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="投用日期" prop="jobs">
                        <el-date-picker
                                size="small"
                                v-model="ruleForm.usedDate"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                type="date"
                                placeholder="选择日期"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="使用期限" prop="jobs">
                        <el-input-number
                                size="small"
                                v-model="ruleForm.serviceLife"
                                controls-position="right"
                                :min="1"
                                :max="1000000"
                        ></el-input-number>
                        <el-button size="small">月</el-button>
                    </el-form-item>
                    <el-form-item label="生命周期" prop="jobs">
                        <el-select size="small" v-model="ruleForm.cycleStatus" placeholder="请添加">
                            <el-option
                                    v-for="item in cycleStatusType"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态" prop="jobs">
                        <el-select size="small" v-model="ruleForm.status" placeholder="请添加">
                            <el-option
                                    v-for="item in statusType"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="使用说明" prop="jobs">
                        <el-upload
                                class="upload-demo"
                                drag
                                :on-change="handleChange"
                                :file-list="fileList"
                                action="/v1/materials/uploadSuppliesFile"
                                multiple
                        >
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">
                                将文件拖到此处，或
                                <em>点击上传</em>
                            </div>
                        </el-upload>
                    </el-form-item>
                </el-form>
                <el-button type="primary" class="addBtn" @click="submitForm()">确定</el-button>
            </template>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";

    export default {
        data() {
            return {
                isAdd: true,
                ruleForm: {},
                rules: {},
                type: [], //物质分类
                cycleStatusType: [
                    {
                        id: 0,
                        name: "已投用"
                    },
                    {
                        id: 1,
                        name: "库存中"
                    },
                    {
                        id: 2,
                        name: "报废"
                    }
                ],
                statusType: [
                    {
                        id: 0,
                        name: "完好"
                    },
                    {
                        id: 1,
                        name: "维修"
                    }
                ],
                fileList: []
            };
        },
        mounted: function () {
            this.getType();
        },
        methods: {
            getType() {
                let param = {};
                param.limit = 10000;
                param.curPage = 1;
                this.componentsMoudel.httpRequest
                    .getRequestHander("/supplies/list_all")
                    .openLoad()
                    .startGet(param)
                    .then(res => {
                        this.type = res.body.data;
                    });
            },
            handleChange(file, fileList) {
                this.fileList = fileList.slice(-3);
            },

            submitForm() {
                var fileArray = [];
                let url = "";
                if (this.isAdd) {
                    for (let item in this.fileList) {
                        var fileInfo = {};
                        fileInfo.fileName = this.fileList[item].name;
                        fileInfo.url = this.fileList[item].response.data;
                        fileArray.push(fileInfo);
                    }
                    url = "/materials/save";
                } else {
                    for (let item in this.fileList) {
                        var fileInfo = {};
                        fileInfo.fileName = this.fileList[item].name;
                        fileInfo.url = this.fileList[item].response.data;
                        fileArray.push(fileInfo);
                    }
                    url = "/materials/update";
                }

                this.ruleForm.suppliesFileDto = fileArray;
                this.componentsMoudel.httpRequest
                    .getRequestHander(url)
                    .openLoad()
                    .startPost(this.ruleForm)
                    .then(res => {
                        this.$message({
                            showClose: true,
                            message: "操作成功",
                            type: "success"
                        });

                        this.$router.push({
                            path: "/processManager/masterial"
                        });
                    });
            }
        },
        created() {
            let obj = this.$route.params.key;
            if (this.$route.params.key) {
                this.ruleForm = obj;
                let files = JSON.parse(obj.suppliesFile);
                this.isAdd = false;
                for (let i = 0; i < files.length; i++) {
                    let myFile = {response: {data: ''}};
                    var file = files[i];
                    myFile.name = file.fileName;
                    myFile.response.data = file.url;
                    this.fileList.push(myFile);
                }
            } else {
                this.ruleForm = {};
            }
        },
        deactivated() { //路由组件失活时时执行函数
            this.$destroy() //路由组件失活时 销毁组件 再次打开重载组件
        }
    };
</script>

<style scoped>
    .addBtn {
        display: block;
        width: 300px;
        margin: 0 auto;
    }

    .myHead {
        position: absolute;
        top: 0px;
        left: 250px;
        width: 80%;
        height: 160px;
    }
</style>
